/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Rail_TotalInputs */

const en_ui_rail_total = /** @type {(inputs: Ui_Rail_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`total`)
};

const de_ui_rail_total = /** @type {(inputs: Ui_Rail_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gesamt`)
};

/**
* | output |
* | --- |
* | "total" |
*
* @param {Ui_Rail_TotalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_total = /** @type {((inputs?: Ui_Rail_TotalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_TotalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_total(inputs)
	return de_ui_rail_total(inputs)
});